export default __webpack_public_path__ + "bd50a366e668a6acd9b37211b44733e7.png";